<template>
  <div class="row" style="background-color: white;">
    <div class="col-md-8" style="padding: 10px; border: 1px solid #ccc">
      <ul class="nav nav-tabs nav-bordered">
        <li v-for="p in productPackageGroupList" :key="p.id" class="nav-item" @click="setPackage(p.id)">
          <a :href="'#' + p.id" data-toggle="tab" aria-expanded="false" class="nav-link">{{ p.category }}</a>
        </li>
        <li class="nav-item">
            <a href="#jetski" data-toggle="tab" aria-expanded="true" class="nav-link">JetSki</a>
        </li>
        <li class="nav-item">
          <a href="#promo" data-toggle="tab" aria-expanded="true" class="nav-link">Promo</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane" v-for="p in productPackageGroupList" :id="p.id" :key="p.id">
          <div class="row">
            <div class="col-md-4" v-for="i in getProductPackageByCategory" :key="i.id">
                <div class="card card-menu" @click="addOrder(i.id)">
                    <div class="card-body">
                      <span class="text-primary">{{ i.product_name }}</span>
                      <ul>
                        <li>Price: Rp. <span class="text-secondary">{{ i.price | currency }}</span></li>
                      </ul>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="tab-pane" id="jetski">
          <div class="row">
            <div class="col-md-4" v-for="i in getAsset" :key="i.id">
                <div class="card card-menu" @click="addUnit(i.id)">
                  <div class="card-body">
                    <span class="text-primary">{{ i.asset_no }}</span>
                    <ul>
                      <li>{{ i.asset_name }}</li>
                      <li>{{ i.internal_number }}</li>
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="tab-pane" id="promo">
          <h5>Promo</h5>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="row">
        <div class="col-md-10 p-1">
          <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false" class="btn btn-sm btn-primary" @click="addCustomer">
            <span v-if="sales.customer.name === null || sales.customer.name === ''">+ Add Customer</span>
            <span v-else><i class="lni lni-user"></i> {{ sales.customer.name }}</span>
          </button>
        </div>
        <div class="col-md-2 p-1">
          <button class="btn btn-sm btn-primary"><i class="lni lni-radio-button"></i> List</button>
        </div>
      </div>
      <div class="row orderList">
        <div class="col-md-12">
          <h5>Order</h5>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Product</th>
                <th></th>
                <th>Qty</th>
                <th></th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, index) in sales.details" :key="index">
                <td>
                  <div><b>{{ d.description }}</b></div>
                  <div><span>{{ d.product_no }}</span></div>
                </td>
                <td>
                  <button type="button" v-if="d.qty < 1" class="btn btn-sm btn-soft-outline-primary" @click="remove(index)"><i class="fa fa-trash"></i></button>
                  <button type="button" v-else class="btn btn-sm btn-soft-primary" @click="minus(index)">-</button>
                </td>
                <td><span style="font-size: 20px;"><b>{{ d.qty }}</b></span></td>
                <td>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="plus(index)"><i class="fa fa-plus"></i></button>
                </td>
                <td>{{ d.price | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row unitList">
        <div class="col-12">
          <table class="table table-sm">
            <tr v-for="(u, index) in sales.units" :key="index">
              <td>
                <div><b>{{ u.name }}</b></div>
                <div>{{ u.internal_number }}</div>
              </td>
              <td><input type="text" class="form-control" v-model="u.start_gas" placeholder="Start Fuel"/></td>
              <td><input type="text" class="form-control" v-model="u.end_gas" placeholder="End Fuel"/></td>
              <td><button type="button" class="btn btn-sm btn-soft-outline-primary" @click="removeUnit(index)"><i class="fa fa-trash"></i></button></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table table-sm">
            <tr>
                <td>Subtotal</td>
                <td class="text-right">{{ getSubtotal | currency }}</td>
            </tr>
            <tr>
                <td>Discount</td>
                <td class="text-right">{{ getDiscount | currency }}</td>
            </tr>
            <tr>
                <td>Tax</td>
                <td class="text-right">{{ getTax | currency }}</td>
            </tr>
            <tr>
                <td><h5>Total</h5></td>
                <td class="text-right">
                  <h5>{{ getTotal | currency }}</h5>
                </td>
            </tr>
          </table>
          <button class="mt-2 btn btn-soft-primary" data-toggle="modal" data-target="#modalPaymentPointOfSales" data-backdrop="static" data-keyboard="false" style="width: 100%" >Charge ( {{ getOutstanding | currency }} )</button>
        </div>
      </div>
    </div>
    <pre>{{ productListAll }}</pre>
    <CustomerListModal @select="selectCustomer" :scroll="corY" ref="refreshCustomer"/>
    <PaymentPointOfSales  @savePayment="savePayment"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CustomerListModal from '@/components/point-of-sales/CustomerListModal.vue'
import PaymentPointOfSales from '@/components/point-of-sales/PaymentPointOfSales.vue'
import Axios from 'axios'
import { getHeader, pointOfSaleUrl } from '@/config'
export default {
  name: 'PointOfSales',
  components: {
    CustomerListModal,
    PaymentPointOfSales
  },
  data () {
    return {
      packageID: null,
      publicPath: process.env.BASE_URL,
      searchQuery: '',
      sales: {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        type: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        branch_no: '100',
        warehouse_no: 'WH0002',
        branch: null,
        subtotal: null,
        tax_id: null,
        taxes: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        salesman_id: null,
        salesman: null,
        status: null,
        price_id: null,
        price_list: null,
        overdue: '',
        order_no: null,
        company_no: null,
        print_counter: '0',
        bstk_counter: '0',
        return_total: '0',
        faktur_no: null,
        faktur_date: null,
        notes: null,
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product_sku: null,
          product: null,
          products: {
            canBarcode: null
          },
          description: null,
          barcode: null,
          qty: null,
          qty_done: null,
          serial_number: null,
          sec_serial_number: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          queue: null,
          warehouse_no: null,
          order_no: null,
          uomType: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: '0',
            active: false,
            cost: '0',
            price: '0'
          }],
          cost: '0',
          cost_id: null,
          margin: '0',
          margin_percentage: '0',
          internal_code: null,
          lock: false
        }],
        returns: [{
          id: null,
          type: null,
          return_no: null,
          return_date: null,
          deliver_date: null,
          purchasing_no: null,
          sale_no: null,
          notes: null,
          status: null,
          branch_no: null,
          branch: null,
          company_no: null,
          company: null,
          lock: false,
          is_deliver: null,
          customer_no: null,
          customer: null,
          vendor_no: null,
          vendor: null,
          subtotal: '0',
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          details: [{
            id: null,
            return_no: null,
            product_no: null,
            product: null,
            product_sku: null,
            serial_number: null,
            uom_id: null,
            qty: null,
            amount: '0',
            notes: null,
            warehouse_no: null,
            warehouse: null,
            branch_no: null,
            company_no: null,
            discount: '0',
            discount_percentage: '0',
            tax_id: null,
            tax: '0',
            subtotal: '0',
            total: '0',
            return_date: null,
            cost: '0',
            cost_id: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          sale_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null,
          group_no: null,
          account_code: null,
          account: null
        }],
        deliveries: [{
          id: null,
          deliver_no: null,
          sale_no: null,
          deliver_date: null,
          notes: null,
          employee_no: null,
          type_id: null,
          branch_no: null,
          company_no: null,
          delivery_term: null,
          details: [{
            id: null,
            deliver_no: null
          }]
        }],
        tables: [{
          id: null,
          table_no: null,
          sale_no: null,
          notes: null,
          start_date: null,
          end_date: null,
          hour: null,
          bar: null,
          finish: null,
          company_no: null
        }],
        total_payment: null
      },
      payment: '0',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      productListAll: state => state.products.productPackageList,
      assetList: state => state.assets.assetList,
      productPackageGroupList: state => state.products.productPackageGroupList
    }),
    getPaymentTotal () {
      var total = 0
      // var array = this.sales.payments
      // for (let i = 0; i < array.length; i++) {
      //   total += array[i].price
      // }
      return total
    },
    getOutstanding () {
      var total = this.getTotal
      var payment = this.getPaymentTotal
      var outstanding = total - payment
      return outstanding
    },
    getAsset: function () {
      return this.assetList.filter(d => d.type_id === 'unit')
    },
    getProductPackageByCategory () {
      return this.productListAll.filter(d => d.category_id === this.packageID)
    },
    getProductPackage: function () {
      return this.productListAll.filter(d => d.type_id === 'Package')
    },
    getPackage: function () {
      return this.productListAll.filter(d => d.type_id === 'Package').filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    getSubtotal: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += array[i].qty * array[i].price
      }
      return sum
    },
    getDiscount: function () {
      return 0
    },
    getTax: function () {
      return 0
    },
    getTotal: function () {
      var total = this.getSubtotal - this.getDiscount + this.getTax
      return total
    }
  },
  methods: {
    setPackage (id) {
      alert(id)
      this.packageID = id
    },
    savePayment (value) {
      console.log(value)
      this.sales.payments.push(value)
    },
    addCustomer () {
      this.$refs.refreshCustomer.refreshList()
    },
    selectCustomer (value) {
      console.log('select customer')
      console.log(value)
      this.sales.customer_no = value.customer_no
      this.sales.customer.name = value.name
    },
    async paymentProcess () {
      await Axios.post(pointOfSaleUrl, this.sales, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    remove (index) {
      this.sales.details.splice(index, 1)
    },
    removeUnit (index) {
      this.sales.units.splice(index, 1)
    },
    plus (index) {
      var detail = this.sales.details[index]
      detail.qty += 1
    },
    minus (index) {
      var detail = this.sales.details[index]
      detail.qty -= 1
    },
    validateNull () {
      var array = this.sales.details.filter(d => d.id === null)
      console.log('validate null')
      console.log(array)
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          this.sales.details.splice(i, 1)
        }
      }
    },
    addOrder (id) {
      this.validateNull()
      const product = this.productListAll.find(d => d.id === id)
      var checkProductNo = this.sales.details.find(d => d.product_no === product.product_no)
      if (checkProductNo) {
        checkProductNo.qty += 1
      } else {
        var array = product.packages
        var loop = []
        for (let i = 0; i < array.length; i++) {
          var pkg = {
            detail_id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            description: array[i].name,
            qty: array[i].qty,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            price: array[i].price,
            tax_id: null,
            tax: null,
            discount: null,
            total: array[i].price,
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: null,
            cost_id: null,
            sec_serial_number: null
          }
          loop.push(pkg)
        }
        var obj = {
          sale_no: null,
          sale_date: null,
          branch_no: null,
          product_no: product.product_no,
          product_sku: null,
          description: product.product_name,
          qty: 1,
          serial_number: null,
          sec_serial_number: null,
          uom_id: product.uom_id,
          price: product.price,
          tax_id: null,
          tax: 0,
          discount: 0,
          total: product.price,
          queue: 0,
          warehouse_no: null,
          internal_code: null,
          cost: null,
          cost_id: null,
          stockouts: loop
        }
        console.log('detail')
        console.log(obj)
        this.sales.details.push(obj)
      }
    },
    validateUnitNull () {
      var array = this.sales.units.filter(d => d.id === null)
      console.log('validate null')
      console.log(array)
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          this.sales.units.splice(i, 1)
        }
      }
    },
    addUnit (id) {
      this.validateUnitNull()
      const asset = this.assetList.find(d => d.id === id)
      var checkAssset = this.sales.units.find(d => d.asset_no === asset.asset_no)
      if (checkAssset) {
        alert('already taken asset')
      } else {
        var obj = {
          asset_no: asset.asset_no,
          name: asset.asset_name,
          serial_number: asset.serial_number,
          internal_number: asset.internal_number
        }
        this.sales.units.push(obj)
      }
    }
  },
  mounted () {
    this.$store.dispatch('getBankPaymentMethodList')
    this.$store.dispatch('getProductPackageList')
    this.$store.dispatch('getAssetList')
    this.$store.dispatch('getCustomerList')
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getProductPackageGroupList')
  }
}
</script>

<style scoped>
.card-menu {
  border: 1px solid #ccc;
  cursor: pointer;
}
.card-menu:hover {
  background-color: #ccc;
}
.orderList {
  padding-top: 10px;
  border: 1px solid #ccc;
  height: 300px;
  overflow-y: auto;
}
.unitList {
  border: 1px solid #ccc;
  /* height: 50px; */
  /* overflow-y: auto; */
}
</style>
